<template>
  <!-- 内容 -->
  <div class="pageCon">
    <div class="w1200">
      <!-- 左边菜单栏 -->
      <div class="leftNav">
        <ul>
          <!-- @click="
              secondIndexCopy = index;
              change();
            " -->
          <li v-for="(item, index) in secondList" :key="index">
            <router-link
              :to="{
                path: '/secondpage',
                query: {
                  index: firstIndex,
                  secondindex: index,
                  thirdindex: '-1',
                },
              }"
              >{{ item.title }}
              <span v-if="item.children" class="el-icon-arrow-down"></span>
            </router-link>
            <ul v-if="item.children">
              <li v-for="(item3, index3) in item.children" :key="index3">
                <router-link
                  :to="{
                    path: '/secondpage',
                    query: {
                      index: firstIndex,
                      secondindex: index,
                      thirdindex: index3,
                    },
                  }"
                  >{{ item3.title }}</router-link
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- 右边内容 -->
      <div class="rightMain">
        <!-- <router-view></router-view> -->
        <div v-if="thirdIndex != '-1'">
          <i></i>{{ secondList[secondIndex].children[thirdIndex].title }}
        </div>
        <div v-else><i></i>{{ secondList[secondIndex].title }}</div>
        <!-- 中心介绍 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 0 && secondIndex == 0"
        >
          <p>
            天津市职工疗休养中心为市总工会直属二类公益事业单位，2020年5月，由天津市第一工人疗养院（天津市职工医院、天津市工伤康复中心）和原天津市北戴河工人疗养院整合组建而成。
          </p>
          <p>
            中心作为天津市康复医学会职业康复专业委员会主委单位、天津市职业性尘肺病康复站和技术支撑单位及天津市区域康复培训指导基地在建单位，目前为天津医科大学、天津中医药大学、天津市体育学院、天津市医学高等专科学校等院校临床教学基地，并与天津市第一中心医院、天津医科大学眼科医院等三甲医院建立医联体，为职工提供专业咨询、预约专家面诊、双向住院转诊等服务。
          </p>
          <p>
            中心承担全市职业病人员的医疗、康复和常见病、多发病、慢性病的诊治与护理以及健康教育；承担全市劳模、先进人物和困难职工、农民工的体检及医疗救助等工作。为职工群众和先进模范提供疗养休养服务。
          </p>
        </div>
        <!-- 中心荣誉 -->
        <div
          class="rightMain_zxry"
          v-show="firstIndex == 0 && secondIndex == 1"
        >
          <div v-for="item in zxryList" :key="item.ArticleId">
            <img
              v-if="item.ScrollImgList && item.ScrollImgList.length > 0"
              :src="item.ScrollImgList[0].ImgUrl"
            />
            <p>{{ item.Title }}</p>
          </div>
        </div>
        <!-- 组织架构 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 0 && secondIndex == 2"
        >
          <img style="width: 90%" src="../../assets/img/zzjg.jpg" alt="" />
        </div>
        <!-- 门诊介绍 -->
        <!-- 门诊设置 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 3 && secondIndex == 0"
        >
          <p>
            门诊服务部内设内科、外科、妇科、眼科、耳鼻喉科、口腔科等科室，以及医学影像科、CT室、肺功能室、骨密度检测室、动脉硬化检测室、电测听室、彩超室、心电图室、医学检验科等医技科室。可提供健康体检、职业健康检查、驾驶员体检、健康咨询、医疗保健及各项诊疗服务。
          </p>
        </div>
        <!-- 口腔门诊 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 3 && secondIndex == 1"
        >
          <p>
            我院口腔科门诊是一个集美学修复、口内、口外及口腔修复综合一体的治疗性科室。科室配备牙根尖X光机、独立的器械处理区及高压灭菌消毒设备。诊疗环境独立温馨舒适，干净整洁；具有丰富临床经验的医师团队，诊疗工作高度认真负责，得到广大患者的一致好评。
          </p>
        </div>
        <!-- 眼科门诊 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 3 && secondIndex == 2"
        >
          <p>
            我院眼科门诊提供日常查体及诊疗，包括视力，眼睑及眼表疾病，如内外睑腺炎、沙眼、结石、结膜炎、翼状胬肉、角膜炎、白内障等眼科疾病诊断。
          </p>
        </div>
        <!-- 尘肺门诊 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 3 && secondIndex == 3"
        >
          <p>
            尘肺门诊自2011年1月增设，我院为职业性尘肺病治疗定点医疗机构，主要负责对工伤职业病尘肺患者日常诊疗。除进行止咳、化痰平喘、抗感染等对症药物治疗外，辅助以健康指导、心理干预、呼吸肌功能训练等为特色的综合康复治疗，帮助患者减少感染和并发病的发生，提高日常生活活动能力，改善心肺功能，延缓尘肺病患者病情进展，提高生活质量和生存率。专门设立门诊病案室，为每名尘肺病就诊患者建立健康档案。
          </p>
        </div>
        <!-- 康复门诊 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 3 && secondIndex == 4"
        >
          <p>
            1、工伤康复：本院自2016年7月新增工伤门诊，作为工伤保险定点医疗机构，主要负责全市工伤患者日常诊疗。以工伤康复为特色，在对脑卒中后遗症、颅脑损伤、脊髓损伤、截肢术后、手外伤、周围神经损伤、骨折、关节软组织损伤、烧伤等进行系统康复评估和运动治疗、作业治疗、言语治疗、心理治疗、日常生活能力训练、物理因子治疗、中医治疗及支具制作等综合康复训练方面积累了丰富经验。
          </p>
          <p>
            2、医保康复：2017年取得医保康复定点医疗机构资质，可以为脑卒中后遗症、骨折等患者提供康复评估、治疗服务。
          </p>
          <p>
            3、中医康复：主要采用中医中药、针灸、推拿、拔罐、熏蒸、理疗、耳针等传统医学疗法，治疗颈椎病、腰椎间盘突出症、面瘫、头痛、脑梗死后遗症、脑出血后遗症、肩关节综合征、膝关节炎等各种慢性、功能性疾病。中医康复具有治疗时间短、副作用少、见效快的特点。
          </p>
        </div>
        <!-- 产后康复门诊 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 3 && secondIndex == 5"
        >
          <p>
            女性在生产完毕后，常会因为身体的一些损伤无法真正在解剖功能恢复，从而造成漏尿、腹直肌分离、耻骨联合分离疼痛、长短腿、肥胖、产后抑郁等一系列的身体功能问题。另一方面，女性由于年龄增长、盆腔手术后、多产或产后护理不当等，会导致盆底肌无力、松弛，造成漏尿、下腰背痛、盆腔脏器脱垂等等，需要通过专业的检查和康复评估，发现盆底肌存在问题，进行有针对性的康复治疗，帮助患者恢复身体功能。
          </p>
          <p>
            产后康复门诊配备了专业的医护和康复治疗师团队，多种先进的评估、康复、理疗设备，独立的治疗室、训练室，为女性朋友提供了优雅私密、温馨放松的诊疗环境。
          </p>
        </div>
        <!-- 内科门诊 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 3 && secondIndex == 6"
        >
          <p>
            我院为医保医疗和医保康复定点医疗机构，内科门诊为广大患者提供呼吸系统、消化系统、内分泌系统以及心脑血管等内科常见病多发病诊疗以及慢性疾病的健康管理服务。
          </p>
        </div>
        <!-- 工伤门诊 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 3 && secondIndex == 7"
        >
          <p>
            本院自2016年7月新增工伤门诊，作为工伤保险定点医疗机构，主要负责全市工伤患者日常诊疗。以工伤康复为特色，在对脑卒中后遗症、颅脑损伤、脊髓损伤、截肢术后、手外伤、周围神经损伤、骨折、关节软组织损伤、烧伤等进行系统康复评估和运动治疗、作业治疗、言语治疗、心理治疗、日常生活能力训练、物理因子治疗、中医治疗及支具制作等综合康复训练方面积累了丰富经验。
          </p>
        </div>
        <!-- 健康体检-体验服务 -->
        <!-- 体检中心介绍 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 4 && secondIndex == 0 && thirdIndex == '-1'"
        >
          <p>
            门诊服务部体检中心集健康体检、职业健康检查、驾驶员体检、健康咨询、医疗保健及诊疗为一体的综合性科室，环境舒适优雅，拥有技术一流的医疗团队，配有先进的医疗设备及功能完善的流动体检车，以崭新的健康理念、规范的管理模式、高标准的体检质量、完善的后续服务提供最优质的服务。
          </p>
          <p>
            作为我中心的服务窗口之一，门诊服务部自成立之日起始终本着“以人为本、健康大众”的服务理念面向社会各界人士，为各行各业入职人员、在职人员、离退休老干部等提供健康体检服务，针对不同人群不同需求设计不同体检套餐30余种。同时，门诊服务部还配备了两辆流动体检车，可为有需要的体检人群提供延伸服务，可深入到工厂、工地、学校、企业郊县等偏远地区，为工人、农民工、学生等一线工作人员进行体检，满足不同企事业单位对健康体检形式的不同需求。
          </p>
          <p>
            门诊服务部在查体过程中始终坚持高标准、严要求的精准服务，以精湛的医疗技术和优质的医疗服务做好体检工作，倡导推行个性化体检服务，为各行各业人员提供详尽的健康咨询。本着对受检者身体健康负责的态度，门诊服务部将防病治病关口前移，对检查出的潜在健康问题，第一时间通知受检人员，使其得到及时的治疗，得到广大社会群体的普遍欢迎和认可。
          </p>
          <p>
            体检中心内设内科、外科、妇科、眼科、耳鼻喉科、口腔科等科室，以及医学影像科、CT室、肺功能室、骨密度检测室、动脉硬化检测室、电测听室、彩超室、心电图室、医学检验科等医技科室，同时配备先进医疗仪器设备，全方位保障广大群众享受目前最先进的医疗服务。
          </p>
          <h1>RevolutionAceES计算机断层扫描（CT）</h1>
          <p>
            拥有百万级成像技术，打造全身高清成像模式，这样的创新带来的不仅仅是成像、尤其是细节成像更为高清和精准，在诊断及鉴别疾病上拥有更高效的诊疗技术。
          </p>
          <p>
            CT检查可用于中枢神经系统疾病、头颈部疾病、胸部疾病、心及大血管、腹及盆腔疾病的诊断。其中中枢神经系统的诊断价值较高，使用更为普遍。
          </p>
          <h1>LOGIQS8超声系统</h1>
          <p>
            其优势为图像优化程序，使图像更加清晰，便于各项临床诊断；高分辨率血流显像技术，增加了血管检查敏感性，克服了标准彩色多普勒血流外溢的弱点。
          </p>
          <p>
            提供多种应用包括常规影像科病人，血管成像，乳腺成像，超声介入，肌骨和各种临床应用。独特编码，展现真正的血管流动显示。具有超强的解析度，敏锐度和穿透力。
          </p>
          <h1>WLD600C 13C呼气分析仪</h1>
          <p>
            摒弃了血清学检验的假阳性可能及胃镜带来的痛苦，同时没有C14的放射性，人体胃内的幽门螺杆菌产生的尿素酶能将尿素［13C］试剂分解成NH3和13C标记的CO2。测量受测者服用尿素［13C］试剂前后呼出气体中13CO2和12CO2含量比值的变化量，从而判断受测者是否感染Hp。
          </p>
          <p>
            具有高效、简单、方便、准确的特点，无辐射，孕妇、儿童、老年人均适用，受测者服用试剂前后分别吹口气即可完成采集。
          </p>
          <h1>悦琦动脉硬化检测仪</h1>
          <p>
            早期筛查外周动脉疾病，特别是无症状外周动脉有无阻塞及动脉僵硬度情况的改变，进一步预测心脑血管疾病
            的发生，用于术前/术后评估。
          </p>
          <p>用于外周动脉硬化及动脉阻塞检测，尽早发现、早诊断、早干预。</p>
          <h1>Sunlight Omnisense 9000骨密度检测仪</h1>
          <p>
            定量超声骨测量仪能在触摸中实现基于超声的骨质疏松症筛查。优化的骨密度评估，具有准确和无创的特点，使筛查有骨质疏松症或骨折风险的人变得快速而简单，从而实现低成本的早期评估、诊断和监测。
          </p>
          <p>
            有多种软件模块和四个民族临床参考数据库可供选择，能对0-99岁的病人进行准确的骨骼筛查。
          </p>
          <h1>宇通数字化健康体检车</h1>
          <p>
            体检车一般采用客车等空间利用率较高的车进行底盘改装，车内空间虽小，功能却很齐全，可提供上门体检服务。
          </p>
          <p>
            车上装配胸部DR机、电测听室、心电超声检查以及检查床、冰柜、空调和紫外线消毒灯等等先进医疗设备，是满足常规体检、职业健康体检的专用车辆。
          </p>
        </div>
        <!-- 健康体检服务 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 4 && secondIndex == 0 && thirdIndex == 0"
        >
          <p>
            门诊服务部内设内科、外科、妇科、眼科、耳鼻喉科、口腔科等科室，以及医学影像科、CT室、肺功能室、骨密度检测室、动脉硬化检测室、电测听室、彩超室、心电图室、医学检验科等医技科室。
          </p>
          <p>
            同时，还配备两辆流动体检车可为有需要的体检人群提供延伸服务，可深入到工厂、工地、学校、企业郊县等偏远地区，为工人、农民工、学生等一线工作人员进行体检，满足不同企事业单位对健康体检形式的不同需求。
          </p>
          <p>健康体检套餐：</p>
          <p>a.入职体检（6款基础套餐可选）</p>
          <p>b.基础健康体检（14款基础套餐可选）</p>
          <p>咨询电话：022-23128023 022-23126531</p>
        </div>
        <!-- 职业健康体检服务 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 4 && secondIndex == 0 && thirdIndex == 1"
        >
          <p>
            我院于2014年7月正式批准为职业健康检查机构，于2020年6月，就职业健康检查（粉尘类、化学因素类、物理因素类、特殊作业类）在天津市卫生健康委员会备案。在各级卫健委、疾控中心、质控中心的指导下，我院认真按照《中华人民共和国职业病防治法》《职业健康检查管理办法》《GBZ188职业健康监护技术规范》《GBZ/T2604职业禁忌证界定导则》以及天津市《DB12T694职业健康检查质量控制规范》《DB609天津市职业健康检查报告编写规范》等规范性文件的要求，开展职业健康检查工作。
          </p>
          <p>体检项目：</p>
          <p>
            依据《职业健康监护技术规范》GBZ188-2014，根据实际接害因素拟定体检项目
          </p>
          <p>咨询电话：022-23131865</p>
        </div>
        <!-- 劳动模范健康体检服务 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 4 && secondIndex == 0 && thirdIndex == 2"
        >
          <p>
            门诊服务部自1990年开始连续30余年承担为全市劳动模范、先进人物提供健康体检服务工作，先后接待劳模查体20余万人次，充分弘扬劳模精神、劳动精神、工匠精神，切实体现党和政府对劳模的关心关爱。
          </p>
          <p>
            体检使用健康体检管理系统，体检数据档案管理电子化、服务人性化，提供体检报告小程序一键查询服务，真正做到准确、快捷、高效，劳模体检信息查询方便快捷。
          </p>
          <p>
            同时也为劳模体检提供健康咨询、疾病预防等后续服务。针对劳模体检不同需求，对有需要的劳模提供量身定制的自增体检项目组合。始终贯穿着“以人为本、健康大众”的服务理念为健康体检提供一流的技术、一流的设备、一流的环境、一流的服务。
          </p>
          <p>劳动模范健康体检套餐：</p>
          <p>a.全国劳模健康体检套餐</p>
          <p>b.市级劳模健康体检套餐</p>
          <p>咨询电话：022-23128023 022-23126531</p>
        </div>
        <!-- 万人免费健康体检服务 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 4 && secondIndex == 0 && thirdIndex == 3"
        >
          <p>
            门诊服务部自2016年起在天津市委、市政府以及市总工会的组织领导下，不断加强为弱势职工群体的关心关爱力度，连续承担20项民心工程为困难职工农民工及新就业形态劳动者免费查体工作，年均接待困难企业职工及农民工查体4万余人次。服务工作面向广大农民工、困难职工和新就业形态劳动者，得到了广大群众的认可与好评，践行人民城市理念，推动健康城镇发展。
          </p>
          <p>
            体检采用院内体检和流动体检车下厂双线并行模式。高峰期日均体检量达800余人次。门诊服务部集中优势力量保障免费查体工作顺利开展，主动靠前服务。每日就具体工作安排提前规划医疗资源，通过错峰预约、增加导诊力度等措施缩短体检等候时间，提高受检者满意度，将面心实的工会职能体现在日常业务工作中。
          </p>
          <p>万人免费体检套餐：</p>
          <p>a.免费查体套餐</p>
          <p>咨询电话：022-23128023 022-23126531</p>
        </div>
        <!-- 职业病（工伤）人员健康体检服务 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 4 && secondIndex == 0 && thirdIndex == 4"
        >
          <p>
            为保障患职业病工伤人员能够及时治疗相关疾病，2009年6月1日开始门诊服务部统一向职业病人员提供健康体格检查服务，中心职业病人员建立健康档案，不断加强体检医疗技术力量，确保体格检查质量，协助积极开展职业病康复工作，切实做到减缓职业病的发展、减少控制并发症、提高职业病人员的生存和生活质量，梳理为工伤职业病人员服务的四项，为广大工伤人员提供优质服务。
          </p>
          <p>职业病（工伤）人员体检套餐：</p>
          <p>a.工伤体检套餐</p>
          <p>咨询电话：022-23128023 022-23126531</p>
        </div>
        <!-- 驾驶员体检服务 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 4 && secondIndex == 0 && thirdIndex == 5"
        >
          <p>
            为了落实公安交管“放管服”优化营商环境新举措，不断延伸车驾管业务办理辐射范围，进一步缩小车驾管服务半径，方便市民办理业务，我院积极响应政策向天津车管所递交材料审核，申请开展驾驶人体检业务，购买设备、组织人员培训，于2021年5月份成功取得了驾驶人体检资质，可办理期满换证、70周岁以上提交身体条件证明体检。体检业务熟练，方便快捷。
          </p>
          <p>体检类别：</p>
          <p>a.对非初学及增驾的驾驶员（不含C5准驾车型）提供期满换证体检服务</p>
          <p>
            b.对70岁以上驾驶员（不含C5准驾车型）提供每年一次提交身体条件证明的体检服务
          </p>
          <p>咨询电话：022-23128023 022-23126531</p>
        </div>
        <!-- 健康体检 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 4 && secondIndex == 0 && thirdIndex == 6"
        >
          <!-- <p style="color: #787878">正在建设中</p> -->
          <div class="rightMain_news1" v-loading="newss1loading">
            <ul
              style="margin-bottom: 2.2rem"
              v-if="jktjList && jktjList.length > 0"
            >
              <li v-for="item in jktjList" :key="item.ArticleId">
                <router-link
                  target="_blank"
                  :to="{
                    path: '/text',
                    query: {
                      articleId: item.ArticleId,
                      index: 4,
                      secondindex: 0,
                    },
                  }"
                >
                  <div class="news1_des">
                    <p>{{ item.Title }}</p>
                  </div>
                </router-link>
              </li>
            </ul>
            <ul v-else>
              <li style="color: #787878">暂无信息</li>
            </ul>
          </div>
        </div>
        <!-- 医疗康复 -->
        <!-- 康复科介绍 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 5 && secondIndex == 0"
        >
          <p>
            康复医学科承担工伤、职业性尘肺病、医保患者的治疗、康复工作。目前开放床位100余张，单独设有康复门诊，近1000平米的康复训练厅分康复评估室、OT治疗区、PT治疗区、ST治疗室、心理治疗室、居家生活模拟区、支具室，拥有荷兰ENRAF
            NONIUS全套肌力训练设备、波兰Brontes情景互动康复训练系统、以色列Medi
            Touch手指及腕关节训练器、德国MOTOmed智能运动训练系统、德国耶格心肺运动功能评测系统等先进的评估训练设备，设有神经康复、肌骨康复、产后康复、心肺康复、工伤康复等二级分科。可收治颅脑损伤、持续性植物状态、脊髓损伤、截肢术后、手外伤、周围神经损伤、骨折、关节软组织损伤、烧伤、尘肺病等各类工伤和职业病患者以及脑卒中、脊髓损伤截瘫、关节置换术后、心肺手术后稳定期的医保患者进行治疗、康复。
          </p>
          <p>
            由康复医师、康复治疗师、康复护士组成专业的MDT康复团队，经过探索和积累，建立了完整工伤康复的诊疗规范体系，对康复的患者实行全流程管理，2009年人社部授牌“天津市工伤康复中心”；2018年成为天津市区域康复培训指导基地。
          </p>
          <p>
            康复医学科在尘肺病康复方面取得的成绩得到市卫健委的肯定，为全市尘肺病康复站建设提供技术支持，成为天津市首批“尘肺病康复站点”。作为国家呼吸临床研究中心呼吸专科医联体医院、天津医科大学总医院呼吸慢病医联体医院、天津市环湖医院神经系统疾病专科联盟医院，保证了患者治疗康复同质化。
          </p>
        </div>
        <!-- 康复项目介绍 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 5 && secondIndex == 1"
        >
          <p>1、康复评定：</p>
          <p>
            肌力评定、关节活动度评定、感觉评定、行走及平衡能力评估、心肺功能评定、言语认知评定、心理评定、日常生活能力及职业能力评定等各种康复相关评估。
          </p>
          <p>2、现代康复治疗技术：</p>
          <p>
            2.1
            物理疗法（PT）：神经发育技术、关节松动术、关节功能训练、肌力训练、步态训练、平衡功能训练等等。
          </p>
          <p>
            2.2
            作业疗法（OT）：包活手功能训练、认知功能训练、职业训练及日常生活训练等方面的作业疗法。
          </p>
          <p>
            2.3
            语言吞咽治疗（ST）：对失语、构音障碍、吞咽障碍的患者进行训练治疗。
          </p>
          <p>
            2.4
            心理治疗：对心理，精神，情绪和行为有异常患者进行个别或集体心理调整或治疗。
          </p>
          <p>2.5 康复护理：如体位处理、心理支持、膀胱护理、肠道护理。</p>
          <p>2.6 康复工程：利用矫形器。惯用肢及辅助器械等以补偿生活能力。</p>
          <p>
            3、物理因子器械治疗：治疗各种炎症、疼痛、痉挛、瘢痕、伤口及创面处理，疗效显著。
          </p>
          <p>
            4、传统康复治疗技术：针灸（含醒脑开窍治疗）、拔罐、推拿按摩、中药熏蒸等。
          </p>
        </div>
        <!-- 康复医疗范围 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 5 && secondIndex == 2"
        >
          <p>
            1、神经系统疾病：脑卒中、颅脑外伤术后后遗症、脊髓损伤截瘫、四肢瘫及其他残疾、周围神经损伤等
          </p>
          <p>
            2、骨关节和肌肉软组织疾病：颈椎病、肩关节周围炎、腰椎间盘突症、腰骶肌劳损、骨性关节炎、软组织损伤、扭挫伤、坐骨神经痛，关节置换术后、截肢术后、骨折术后、肌腱断裂伤术后、手外伤术后等外伤或术后关节功能障得；骨质疏松症、腱鞘炎、筋膜炎等。
          </p>
          <p>3、盆底肌功能障碍</p>
          <p>4、心肺术后及功能障碍</p>
          <p>5、其他疾病：烧伤后肢体功能障碍及肿瘤术后的康复</p>
        </div>
        <!-- 产后康复门诊 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 5 && secondIndex == 3"
        >
          <p>
            女性在生产完毕后，常会因为身体的一些损伤无法真正在解剖功能恢复，从而造成漏尿、腹直肌分离、耻骨联合分离疼痛、长短腿、肥胖、产后抑郁等一系列的身体功能问题。另一方面，女性由于年龄增长、盆腔手术后、多产或产后护理不当等，会导致盆底肌无力、松弛，造成漏尿、下腰背痛、盆腔脏器脱垂等等，需要通过专业的检查和康复评估，发现盆底肌存在问题，进行有针对性的康复治疗，帮助患者恢复身体功能。
          </p>
          <p>
            产后康复门诊配备了专业的医护和康复治疗师团队，多种先进的评估、康复、理疗设备，独立的治疗室、训练室，为女性朋友提供了优雅私密、温馨放松的诊疗环境。
          </p>
        </div>
        <!-- 疗休养工作 -->
        <!-- 北戴河疗养院 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 6 && secondIndex == 0"
        >
          <p>
            天津市北戴河工人疗养院始建于1951年，座落在驰名中外的避暑胜地——北戴河海滨风景区的繁华地带，由四个自然院落构成，占地147亩，建筑面积3.82万平米。建院70多年来，曾接待全国各级劳动模范、先进工作者、一线职工以及众多国家和地区的国际友人。
          </p>
          <p>
            2004年被中华全国总工会确定为“全国劳模疗休养基地”“全国工会先进疗养院”。
            疗养院近年来连续被评为“优质服务优胜单位”“花园式单位”“文明单位”“综合治理模范单位”等荣誉称号。
          </p>
          <p>
            疗养院内绿树成荫、环境清幽、气候宜人。十几栋疗养楼掩映在松林花木之中，您足不出户便可欣赏到这里的蓝天、白云、山峦、海景。疗养院主院落距离海滨浴场200米，金海湾度假村紧邻海滩，浴场水质清澈、沙软潮平。
          </p>
          <p>
            疗养院配备各种接待疗休养业务所需的设施设备，品类众多、功能齐全。拥有数百套高、中档标间、套房，床位600余张，设有大、中、小各式餐厅，可同时容纳700余人就餐或举行宴会。设置大小多功能厅、棋牌室、球类室、健身房、网球场等文体娱乐设施，可以充实您的休闲度假时光。设有大、中、小会议厅及电影播放室，可满足不同类型的会议需求。设置盐疗、玉石疗等理疗设备，可以为您调理疲惫的身心。疗养院还配备大客车、中巴车、商务车等各种车辆，形成接送站、游览、观光、住宿、餐饮、会议、理疗为一体的一条龙式疗休养服务网络。
          </p>
          <p>
            涛声依旧、初心不悔，疗养院在“回归公益、聚焦主业、自主经营、依法监管”的整体要求下，充分发挥公益性、服务性的优势，不断拓展服务项目，不断提升服务品质。疗养院全体干部职工正以饱满的热情，竭诚欢迎全国各地的劳动模范、先进工作者、一线职工及各界朋友来我单位疗休养、休闲度假。
          </p>
          <img src="../../assets/img/lxyjd/yljs/bdh-syt.jpg" alt="" />
          <img src="../../assets/img/lxyjd/yljs/ss01.jpg" alt="" />
        </div>
        <!-- 疗休养服务 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 6 && secondIndex == 1"
        >
          <p>
            1、个性化疗休养方案：根据疗养人员特点，按实际需求和健康状况，为其量身定制合理的疗休养方案，包括安逸的住宿、轻松的休闲活动和营养膳食等。
          </p>
          <p>
            2、心理咨询服务：为疗养员提供专业的健康心理咨询服务，包括心理健康评估、疾病预防、慢性病管理等，以帮助他们了解自己的健康状况并采取相应的改善措施。
          </p>
          <p>
            3、康复理疗服务：中心大理道院区安排专业的康复保健医师，提供物理治疗，同时北戴河院区康养之家可进行玉石疗、盐疗等体验，帮助客户缓解疼痛、恢复身体功能，放松身心。
          </p>
          <p>
            4、休闲娱乐活动：组织各种休闲娱乐活动，如院内观影、健身、球类运动，座谈学习交流、书画友谊赛、各类专家讲座、趣味运动会、联谊会、外出参观游览等，满足疗养员在疗休养过程中的多元化需求。
          </p>
        </div>
        <!-- 外埠合作疗养院 -->
        <!-- <div
          class="rightMain_zxjs"
          v-show="firstIndex == 6 && secondIndex == 2 && thirdIndex == '-1'"
        >
          <p>
            为不断拓展劳模、技术工人疗休养范围和内涵，提高疗休养活动的生机活力和服务质量水平，职工疗休养中心与多家外省市工会疗休养基地开展合作，各级工会组织可委托我中心组织赴外省市疗休养工作。如有其他疗休养路线需求，也可委托中心协调安排。联系电话：022—23316850。
          </p>
        </div> -->
        <!-- 联系我们 -->
        <!-- 来院路线 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 7 && secondIndex == 0"
        >
          <h3>大理道院区</h3>
          <a>
            <p style="width: 100%">地址:天津市和平区大理道60号</p>
            <p style="width: 100%">电话: 022-23126531/23128023</p>
          </a>
          <p style="font-weight: 600; text-indent: 0 !important">交通路线</p>
          <!-- <h6>地铁：</h6> -->
          <!-- <el-divider content-position="left">地铁</el-divider> -->
          <a>
            <p style="width: 100%">
              地铁1号线 小白楼站或营口道站下，骑行10分钟左右
            </p>
            <p style="width: 100%">
              地铁3号线 营口道站或西康路站下，骑行10分钟左右
            </p>
            <p style="width: 100%">地铁4号线 徐州道站下，骑行10分钟左右</p>
          </a>
          <el-divider></el-divider>
          <a>
            <p><span>天和医院站</span><span>908</span></p>
            <p><span>马场道站</span><span>619</span></p>
            <p><span>昆明路站</span><span>858，校线2（单向）</span></p>
            <p><span>云南路站</span><span>800，838，870</span></p>
            <p><span>湛江路站</span><span>13，685，862，871，904</span></p>
            <p><span>外国语大学站</span><span>906，954</span></p>
            <p style="width: 100%">
              <span>桂林路站</span><span>观光2路，9，831，845，902，951</span>
            </p>
          </a>
          <el-divider></el-divider>
          <img src="../../assets/img/lxwm/dldyq-lx.jpg" alt="" />

          <div style="margin-top: 2.2rem"></div>
          <h3>北戴河院区</h3>
          <p style="font-weight: 600; text-indent: 0 !important">交通路线</p>
          <a>
            <p style="width: 100%">
              北戴河火车站乘坐5路公交到“北戴河医院”站转乘15路到“管道局”站下
            </p>
          </a>
          <el-divider></el-divider>
          <img src="../../assets/img/lxwm/bdhyq-lx.jpg" alt="" />
        </div>
        <!-- 院内地图 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 7 && secondIndex == 1"
        >
          <h3 style="text-align: center">大理道院区</h3>
          <img src="../../assets/img/lxwm/dldyq-yndt.jpg" alt="" />
          <h3 style="text-align: center">北戴河院区</h3>
          <img src="../../assets/img/lxwm/bdhyq-yndt.jpg" alt="" />
        </div>
        <!-- 联系电话 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 7 && secondIndex == 2"
        >
          <p><span>办公室</span>：23316850</p>
          <p><span>医疗</span>：23126381</p>
          <p><span>康复</span>：23391286</p>
          <p><span>体检</span>：23128023</p>
          <p><span>疗休养</span>：15033527324</p>
          <p><span>行风投诉</span>：23114800</p>
        </div>
        <!-- 公众号 -->
        <div
          class="rightMain_zxjs"
          v-show="firstIndex == 7 && secondIndex == 3"
        >
          <img src="../../assets/img/gzh.jpg" alt="" srcset="" />
        </div>
        <!-- 动态 -->
        <div
          class="rightMain_news2"
          v-loading="newssloading"
          v-show="
            firstIndex == 1 ||
            firstIndex == 2 ||
            (firstIndex == 4 && secondIndex == 1) ||
            (firstIndex == 5 && secondIndex == 4) ||
            (firstIndex == 6 && secondIndex == 2 && thirdIndex == '-1')
          "
        >
          <ul style="margin-bottom: 2.2rem" v-if="list && list.length > 0">
            <li v-for="item in list" :key="item.ArticleId">
              <router-link
                target="_blank"
                :to="{
                  path: '/text',
                  query: {
                    articleId: item.ArticleId,
                    index: firstIndex,
                    secondindex: secondIndex,
                  },
                }"
              >
                <div class="news2_img">
                  <img
                    v-if="item.ScrollImgList[0].ImgUrl"
                    :src="item.ScrollImgList[0].ImgUrl"
                  />
                  <img v-else src="../../assets/img/tjszgyy01.jpg" alt="" />
                </div>
                <div class="news2_des">
                  <p>{{ item.Title }}</p>
                  <p
                    v-if="
                      firstIndex == 6 && secondIndex == 2 && thirdIndex == '-1'
                    "
                  ></p>
                  <p v-else>{{ item.Time }}</p>
                  <p>{{ item.content }}</p>
                </div>
              </router-link>
            </li>
          </ul>
          <ul v-else>
            <li style="color: #787878">暂无信息</li>
          </ul>
          <el-pagination
            :hide-on-single-page="true"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>     

<script>
import $ from "jquery";

export default {
  data() {
    return {
      newssloading: true,
      firstIndex: 0,
      secondIndex: 0,
      thirdIndex: "-1",
      secondList: [],
      id: "",
      currentPage: 1,
      pageSize: 5,
      total: 0,
      // 动态
      list: [],
      // 中心荣誉
      zxryList: [],
      // 健康体检
      jktjList: [],
      newss1loading: true,
    };
  },
  created() {},
  mounted() {},
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(to, from) {
        this.firstIndex = to.query.index;
        this.secondIndex = to.query.secondindex;
        if (!(typeof to.query.thirdindex === "undefined")) {
          this.thirdIndex = to.query.thirdindex;
        } else {
          this.thirdIndex == "-1";
        }
        this.secondList = this.NavList[this.firstIndex].second;
        this.currentPage = 1;
        let that = this;
        if (this.firstIndex == 0) {
          this.getList(
            1,
            999,
            "a360a737-df00-4dee-8b13-37ef9661fc27",
            "zxryList"
          );
        } else if (this.firstIndex == 1) {
          //新闻资讯
          switch (this.secondIndex) {
            case "0": //公示公告
              that.id = "ab34dea7-14e8-4a71-ac7c-6acf5895fd2f";
              break;
            case "1": //医院动态
              that.id = "c0a62f93-5e28-450a-b596-52a358717db5";
              break;
            case "2": //疗休养工作动态
              that.id = "db8ef081-09f7-464d-9437-b1a00bf7f358";
              break;
            case "3": //健康科普
              that.id = "82410bd2-26f9-4344-839f-648c60710e11";
              break;
            case "4": //护理园地
              that.id = "33c88e11-c993-4b01-bf44-0de4cf3c15e2";
              break;
          }
          this.getList(
            this.currentPage,
            this.pageSize,
            this.id,
            "list",
            "newssloading"
          );
        } else if (this.firstIndex == 2) {
          //党建园地
          //新闻资讯
          switch (this.secondIndex) {
            case "0": //党建信息
              that.id = "c55fd94e-b297-41d2-8314-920f983641a6";
              break;
            case "1": //主题教育
              that.id = "177c3ead-d7da-4408-8ffe-b7b3f2936776";
              break;
            case "2": //支部建设
              that.id = "e4593255-7cff-45b8-9295-49f0b65fab0f";
              break;
            case "3": //党员风采
              that.id = "2eba80e0-73f6-44e7-8a2f-e212478c7ec2";
              break;
            case "4": //廉政建设
              that.id = "28a5b5ae-7db1-4d9a-97bf-8340762e2638";
              break;
          }
          this.getList(
            this.currentPage,
            this.pageSize,
            this.id,
            "list",
            "newssloading"
          );
        } else if (this.firstIndex == 4 && this.secondIndex == 0) {
          this.id = "02ff176b-5c3c-4a5d-9855-896f5dc87ef3";
          this.getList(1, 50, this.id, "jktjList", "newss1loading");
        } else if (this.firstIndex == 4 && this.secondIndex == 1) {
          this.id = "40e03533-d4e5-4cee-a10b-4fb18b3e830e";
          this.getList(
            this.currentPage,
            this.pageSize,
            this.id,
            "list",
            "newssloading"
          );
        } else if (this.firstIndex == 5 && this.secondIndex == 4) {
          this.id = "b1aa79d2-7bad-4b49-8ad2-b012b18b77ca";
          this.getList(
            this.currentPage,
            this.pageSize,
            this.id,
            "list",
            "newssloading"
          );
        } else if (this.firstIndex == 6 && this.secondIndex == 2) {
          this.id = "24decc3e-3e45-4562-b4cf-4bc9471c8387";
          this.getList(
            this.currentPage,
            this.pageSize,
            this.id,
            "list",
            "newssloading"
          );
        }
      },
    },
  },
  methods: {
    // 获取数据
    getList(pageIndex, pageSize, articlesTypeId, list, loading) {
      this[loading] = true;
      let url = this.Api + "/webapi/Article/GetArticleListByType";
      let item = {
        PageIndex: pageIndex,
        PageSize: pageSize,
        ArticlesTypeId: articlesTypeId,
      };
      let that = this;
      $.ajax({
        url: url,
        type: "POST",
        data: item,
        dataType: "json",
        success: function (res) {
          if (res.status === 1) {
            that[list] = res.messageJson;
            that.total = res.Total;
            that[loading] = false;
          }
        },
        error: function (error) {
          console.log(error);
        },
      });
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getList(this.currentPage, this.pageSize, this.id, "list");
      $(window).scrollTop(0);
    },
  },
};
</script>
<style scoped>
/* 中间内容 */
.pageCon {
  width: 100%;
  min-height: 70vh;
  background: #fff;
}
.pageCon > div {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin: 0 auto;
  padding: 3rem 0;
}
.pageCon .leftNav {
  width: 20rem;
}
/* 二级 */
.pageCon .leftNav > ul > li {
  list-style: none;
  font-size: 1.35rem;
  text-align: center;
  cursor: pointer;
  background: #0182ac;
}
.pageCon .leftNav > ul > li > a {
  display: inline-block;
  width: 100%;
  /* width: 100%;
  height: 100%; */
  padding: 1.4rem 0.5rem;
  box-sizing: border-box;
  color: #fff;
  border-bottom: 1px solid #fff;
}
.pageCon .leftNav > ul > li :hover > a,
.pageCon .leftNav > ul > li > a:hover {
  color: #00b1e2;
}
/* 三级 */
.pageCon .leftNav > ul > li > ul > li {
  list-style: none;
  font-size: 1.2rem;
  text-align: center;
  cursor: pointer;
  background: rgb(0, 152, 202);
}
.pageCon .leftNav > ul > li > ul > li > a {
  display: inline-block;
  width: 100%;
  /* width: 100%;
  height: 100%; */
  padding: 1.4rem 1rem;
  box-sizing: border-box;
  color: #fff;
  border-bottom: 1px solid #ffffff95;
}
.pageCon .rightMain {
  width: calc(100% - 20rem);
  padding: 0 2rem;
  padding-left: 5rem;
  box-sizing: border-box;
}
.pageCon .rightMain > div:nth-child(2) {
  margin-bottom: 3.6rem;
  position: relative;
}
/* 右边内容标题 */
.pageCon .rightMain > div:nth-child(1) {
  color: #02a1cd;
  height: 5rem;
  font-size: 1.85rem;
  /* font-size: 24px; */
  font-weight: 500;
  box-sizing: border-box;
  padding: 0.57rem 0 0 2.85rem;
  position: relative;
  left: -2.85rem;
  /* transform: translateX(-50%); */
}
.pageCon .rightMain > div:nth-child(1) > i {
  display: inline-block;
  width: 0.35rem;
  height: 2.5rem;
  background: #02a1cd;
  vertical-align: middle;
  margin-right: 1.1rem;
  border-radius: 2px;
}
/* 中心介绍 */
.rightMain_zxjs > img {
  width: 70%;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin: 0.5rem 0;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}
.rightMain_zxjs > p {
  font-size: 1.3rem;
  line-height: 200%;
  text-align: justify;
  text-indent: 2.6rem;
  letter-spacing: 0.07rem;
  /* margin: 1.4rem 0; */
}
.rightMain_zxjs > span {
  display: block;
  font-size: 1.3rem;
  line-height: 200%;
}
.rightMain_zxjs > h1 {
  text-align: center;
  line-height: 200%;
  font-size: 1.5rem;
}
.rightMain_zxjs > p > span {
  display: inline-block;
  width: 6rem;
  height: 100%;
  text-align-last: justify;
  text-indent: 0;
}
.rightMain_zxjs > a {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /* margin: 0.5rem 0; */
}
.rightMain_zxjs > a > p {
  width: 49%;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  font-size: 1.3rem;
  line-height: 200%;
  letter-spacing: 0.07rem;
}
.rightMain_zxjs > a > p > span {
  display: block;
}
.rightMain_zxjs > a > p > span:nth-child(1) {
  width: 12.1rem;
}
.rightMain_zxjs > a > p > span:nth-child(2) {
  width: calc(100% - 12.1rem);
}
.rightMain_zxjs > h3 {
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 200%;
  letter-spacing: 0.14rem;
}
/* .rightMain_zxjs > h5 {
  font-size: 1.28rem;
  font-weight: 600;
  line-height: 200%;
  letter-spacing: 0.07rem;
}
.rightMain_zxjs > h6 {
  font-size: 1.28rem;
  font-weight: 600;
  line-height: 210%;
  letter-spacing: 0.07rem;
} */
/* 文字列表 */
.rightMain_news1 li {
  list-style: none;
  font-size: 1.14rem;
}
/* 新闻资讯2 */
.rightMain_news2 li {
  list-style: none;
  font-size: 1.14rem;
}
.rightMain_news2 li > a,
.rightMain_news1 li > a {
  width: 100%;
  height: 12.9rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  border-bottom: #dbdbdb 1px solid;
  text-decoration: none;
  padding: 1.1rem 0.7rem;
  box-sizing: border-box;
}
.rightMain_news1 li > a {
  height: 4.4rem;
}
.news1_des {
  width: 100%;
  height: 90%;
  color: #333;
}
.news1_des > p {
  font-size: 1.3rem;
  overflow: hidden;
  font-weight: 500;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.news2_img {
  width: 19.3rem;
  height: 100%;
  overflow: hidden;
  position: relative;
}
.news2_img > img {
  width: 100%;
  height: 90%;
  object-fit: cover;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.news2_des {
  width: calc(100% - 19.3rem - 1.3rem);
  height: 90%;
  color: #333;
}
.news2_des > p {
  margin-bottom: 1.1rem;
}
.news2_des > p:nth-child(1) {
  font-size: 1.3rem;
  overflow: hidden;
  font-weight: 500;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.news2_des > p:nth-child(2) {
  color: #787878;
}
.news2_des > p:nth-child(3) {
  font-size: 1.1rem;
  line-height: 180%;
  /* height: 4rem; */
  text-align: justify;
  color: #464646;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.rightMain_news2 li > a:hover,
.rightMain_news1 li > a:hover {
  background: #0181ac19;
  cursor: pointer;
}
/* 中心荣誉 */
.rightMain_zxry {
  width: 100%;
  display: flex;
  /* justify-content: flex-start; */
  justify-content: space-around;
  flex-wrap: wrap;
}
.rightMain_zxry > div {
  width: 31.3%;
  /* height: 220px; */
  margin: 2% 1%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background: #fff;
}
.rightMain_zxry > div > img {
  width: calc(100% - 2.1rem);
  margin: 1.1rem;
  height: 11.5rem;
}
.rightMain_zxry > div > p {
  font-size: 1.2rem;
  padding: 0 1.1rem;
  padding-bottom: 1.4rem;
  box-sizing: border-box;
  text-align: center;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
}
</style>
